<template>
  <el-row>
    <el-col>
      <el-menu
        :router="routerMode"
        class="el-menu-vertical-demo full-height"
        background-color="#304156"
        text-color="#bfcbd9"
        :default-active="activeIndex"
        :collapse-transition="true"
        :unique-opened="true"
      >
        <slot name="trademark" />
        <slot name="router" />
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      routerMode: true,
    };
  },
  computed: {
    ...mapState(["activeIndex"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      console.log(this.$route);
      return path;
    },
  },
};
</script>

<style lang="less">
.full-height {
  height: 100vh;
}
.el-menu-vertical-demo {
  .el-menu {
    overflow: hidden;
    overflow-y: auto;
  }
  .el-submenu .el-menu-item {
    background-color: #001528 !important;
    &:hover {
      background-color: #263445 !important;
    }
  }
}
</style>
